import React, {useState, useEffect} from 'react';
import { Table } from 'react-bootstrap';
import { Form, Button, Row, Col, Card } from "react-bootstrap";
import {Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAlignLeft } from "@fortawesome/free-solid-svg-icons";
import { useSelector} from 'react-redux';
import { useParams } from "react-router"; 
import { doSocialMediaCreate, getSocialMedia, doSocialMediaUpdate } from '../../Service';
import Swal from "sweetalert2";
 
import Rightbar from './Rightbar';
  
export default function SocialMedia(){ 
const [sidebar, setsidebar] = useState(false);
const [mainbar, setmainbar] = useState(false);
const [socialmediaid, setSocialmediaid] = useState('');
const initialValues = { instagram_url: '', facebook_url: "", twitter_url: "", user_id: "", payment_id: "" };
const [formValues, setFormValues] = useState(initialValues);
const [formErrors, setFormErrors] = useState({});
const [allpost, setAllpost] = useState({});

const toggle = () => {
    setsidebar(!sidebar);
    setmainbar(!mainbar);
}
const loggedUser = useSelector(store => store.user['user'])
const id = loggedUser.id;
const payment_id = useParams();

useEffect(() => {
    let params = {'id':payment_id.payment_id};
    getSocialMedia(params).then(res => firstHandleResponse(res.data))
}, []);

const firstHandleResponse = (response) => {
    if(response.code==200){
        setFormValues({instagram_url : response.data.data[0].instagram_url, facebook_url : response.data.data[0].facebook_url, twitter_url : response.data.data[0].twitter_url});
        setSocialmediaid( response.data.data[0].id);
        setAllpost(response.data.data[0].all_post);
        
    } else {
      console.log('no data');
    } 
}

const hanldeChange = (e) => {
    const value=e.target.value;
    const field=e.target.name;
    setFormValues(prevState => ({
        ...prevState,
        [field]:  value  }));
}

const handleSubmit = (e) => {
    e.preventDefault();
    const errorCount = validate(formValues);
    setFormErrors(errorCount);
    if(errorCount.status){
        if(socialmediaid != ''){
            setFormValues(formValues['id'] = socialmediaid);
            doSocialMediaUpdate(formValues).then(res => handleResponse(res));
        }else{
            setFormValues(formValues['payment_id'] = payment_id.payment_id);
            setFormValues(formValues['user_id'] = id);
            doSocialMediaCreate(formValues).then(res => handleResponse(res));
        }
    }
}

const handleResponse = (response) => {
    if(response.data.code==200){
        Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Social Media Created Successfully!',
            showConfirmButton: false,
            timer: 2500
        })
        setSocialmediaid(response.data.data.item.id);
        setFormValues(response.data.data.item);
    } else {
      const errors = {};
      errors.invalid = response.data.data.message;
      errors.status = false;
      setFormErrors(errors);
    }  
}

const validate = (values) => {
    const errors = {};
    errors.status = true;
    const insta_url_regex = /^@[a-zA-Z0-9_]{4,20}$/;
    const facebook_url_regex = /^(https?:\/\/)?((w{3}\.)?)facebook.com\/.*/i;
    const twitter_url_regex = /^@[a-zA-Z0-9_]{4,20}$/;

    if(!values.instagram_url){
        errors.instagram_url = 'Instagram handle is required';
        errors.status = false;
    } else if(values.instagram_url && !insta_url_regex.test(values.instagram_url)) {
        errors.instagram_url = "This is not a valid Instagram handle, must include @ Symble.";
        errors.status = false;
    }

    if(!values.facebook_url){
        errors.facebook_url = 'Facebook page URL is required';
        errors.status = false;
    } else if(values.facebook_url && !facebook_url_regex.test(values.facebook_url)) {
        errors.facebook_url = "This is not a valid Facebook page URL.";
        errors.status = false;
    }

    if(!values.twitter_url){
        errors.twitter_url = 'Twitter handle is required';
        errors.status = false;
    } else if(values.twitter_url && !twitter_url_regex.test(values.twitter_url)) {
        errors.twitter_url = "This is not a valid Twitter handle, must have @ symble and min 4 char.";
        errors.status = false;
    }

    return errors;
  }

return(
  <>
<section className="sec-container" >
   <div className='container'>
      <div className='portalevent'>
         <div className='row'>
            <div className={`col-md-3 portal-sidebar leftbar-close ${sidebar ? 'close' : ''}`}>
                  <div >
                  <Rightbar/>
                  </div>
               </div>
               <div className={`col-md-9 rightbar-open ${mainbar ? 'open' : ''}`}>
                  <div className='rightbar '>
                  <Button variant="outline-info" onClick={toggle}>
                    <FontAwesomeIcon icon={faAlignLeft} />
                  </Button>
                  <div className='social-media'>
                  <h1>SOCIAL MEDIA CONTENT</h1>
                            <p>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor 
                                incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud 
                                exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure 
                                dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. 
                                Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt 
                                mollit anim id est laborum.
                            </p>
                            <h3>Your Social Media Info</h3>
                            
                            <Form onSubmit={handleSubmit}>
                                <Form.Group controlId="exampleForm.ControlInput1">
                                    <Form.Label>Instagram Handle</Form.Label>
                                    <Form.Control type="text" placeholder="Instagram Handle" defaultValue={formValues.instagram_url} name="instagram_url" onChange={hanldeChange}/>
                                    <p className="error">{formErrors.instagram_url}</p>
                                </Form.Group>
                                <Form.Group controlId="exampleForm.ControlInput1">
                                    <Form.Label>Facebook Page URL</Form.Label>
                                    <Form.Control type="text" placeholder="Facebook Page URL" defaultValue={formValues.facebook_url} name="facebook_url" onChange={hanldeChange}/>
                                    <p className="error">{formErrors.facebook_url}</p>
                                </Form.Group>
                                <Form.Group controlId="exampleForm.ControlInput1">
                                    <Form.Label>Twitter Handle</Form.Label>
                                    <Form.Control type="text" placeholder="Twitter Handle" defaultValue={formValues.twitter_url} name="twitter_url" onChange={hanldeChange}/>
                                    <p className="error">{formErrors.twitter_url}{formErrors.invalid}</p>
                                </Form.Group>
                                <br/>
                                <div className='text-center'>
                                <Button className='common-btn' type='submit'>SAVE</Button>{' '}
                                <Button className='cancel-btn'>CANCEL</Button>{' '}
                                </div>
                                <br/>
                                <Row xs={1} md={3} className="g-4 social-media-img" style={{display: socialmediaid != '' ? 'flex' : 'none'}}>
                                    {   socialmediaid != '' && allpost != '' ? 
                                        Object.values(allpost).map((row, index) => (
                                            <Col key={index}>
                                                <Card style={{"textAlign" : "center"}}> 
                                                    <Link to={"/AddPost/" + socialmediaid + "?postid="+row.id}><Card.Img variant="top" src={row.thumbnail_path != null ? row.thumbnail_path : process.env.PUBLIC_URL+'/'+row.physical_path}/></Link>
                                                    <Card.Body>
                                                    <Card.Title>{row.subject}</Card.Title>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        )) : ''
                                    }
                                    { Object.keys(allpost).length < 9 ? (
                                    <Col>
                                        <Card style={{"textAlign" : "center"}}> 
                                            <Link to={"/AddPost/" + socialmediaid}><Card.Img variant="top" src={process.env.PUBLIC_URL+'/images/default-img.png'}/></Link>
                                            <Card.Body>
                                            <Card.Title>ADD POST</Card.Title>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    ) : ''
                                    }
                                </Row>
                                

                            </Form>
                            <br/> 
                            </div>
                  </div>
            </div>
         </div>
      </div>
   </div>
</section>  

 
</>
)
}